import React from 'react';

import { RunningExperiments, useExperiments } from 'state/experiments';

import { EnvList } from './env-list';
import { HiddenSection } from './hidden-section';

const ExperimentFlagsContent = () => {
  const { allVariants } = useExperiments();
  const flags = Object.values(RunningExperiments)
    .filter(s => typeof s === 'string')
    .reduce<Record<string, string>>((acc, flagKey) => {
      acc[flagKey] = allVariants[flagKey]?.value ?? 'OFF';
      return acc;
    }, {});

  return <EnvList data={flags} />;
};

export const ExperimentFlags = () => (
  <HiddenSection title="Experiments" content={<ExperimentFlagsContent />} />
);
